export const zIndices = {
  toast: 100,
  navbar: 15,
  drawer: 999,
};
